.pagination {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin: 16px 0;
  list-style: none;
  padding: 0;
  margin: 0;
}

.pagination li {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  min-width: 36px;
  height: 36px;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.pagination li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: #0d6efd;
  font-size: 14px;
}

.pagination li:hover {
  background-color: #e9ecef;
}

.pagination li.active:hover {
  background-color: #0d6efd;
}

.active {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.active a {
  color: #fff !important;
  font-weight: 500;
}
